import { collection, query, where, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';

// 2026-08-19: shared by the TMDB auto-fill for director/writer (directors collection)
// and cast (cast collection) -- exact-name match first (reliable since TMDB returns the
// same spelling for a person every time), create a new record in the same shape
// AddDirectorInline.js / AddActorInline.js already use if no match is found.
//
// Deliberately exact-match, not fuzzy: this runs unattended across potentially
// hundreds of person lookups during bulk entry, and a wrong fuzzy match would silently
// attribute one person's credit to a different person's existing record.
export async function findOrCreatePerson(firestore, auth, collectionName, name) {
    if (!name) {
        return null;
    }

    const peopleCollection = collection(firestore, collectionName);
    const existingQuery = query(peopleCollection, where('name', '==', name));
    const snapshot = await getDocs(existingQuery);

    if (!snapshot.empty) {
        const doc = snapshot.docs[0];
        return { guid: doc.id, name: doc.data().name };
    }

    const docRef = await addDoc(peopleCollection, {
        creator: auth.currentUser.uid,
        created: serverTimestamp(),
        name,
        nameidx: name.toLowerCase(),
        deleted: false,
    });

    return { guid: docRef.id, name };
}

// Runs findOrCreatePerson for a list of names, in order, returning [{guid, name}, ...].
// Skips (doesn't throw on) individual lookup failures so one bad name doesn't block the
// rest of the auto-fill -- logs a console warning instead.
export async function findOrCreatePeople(firestore, auth, collectionName, names) {
    const results = [];
    for (const name of names) {
        try {
            const person = await findOrCreatePerson(firestore, auth, collectionName, name);
            if (person) {
                results.push(person);
            }
        } catch (e) {
            console.warn(`[personLookup] failed to find/create "${name}" in ${collectionName}:`, e);
        }
    }
    return results;
}
